const datas = [
  { id: 0, name: "住宅火險" },
  { id: 1, name: "商業火險" },
  { id: 2, name: "住家綜合保險" },
  { id: 3, name: "地震保險" }
];
export default datas;

export const contract_type_enum = window._.keyVal(datas, "id", "name");
